export enum NotificationAction {
  NewMeetingRequestV2 = 'new_meeting_request_v2',
  MeetingConfirmedV2 = 'meeting_confirmed_v2',
  MeetingCanceledV2 = 'meeting_canceled_v2',
  MeetingRescheduledV2 = 'meeting_rescheduled_v2',
  MeetingReminderV2 = 'meeting_reminder',
  CustomPush = 'custom_push',
}
